import React from 'react';
import Layout from '../components/Layout';

function Dashboard() {
  // Örnek veriler (sonra API'den gelecek)
  const stats = {
    income: 45230,
    expense: 18450,
    profit: 26780,
    invoiceCount: 12,
  };

  const recentTransactions = [
    { id: 1, date: '05 Kas', description: 'Ayşe Hanım - Hizmet Bedeli', amount: 2500, type: 'income' },
    { id: 2, date: '04 Kas', description: 'Elektrik Faturası', amount: -450, type: 'expense' },
    { id: 3, date: '03 Kas', description: 'Mehmet Bey - Danışmanlık', amount: 1800, type: 'income' },
    { id: 4, date: '02 Kas', description: 'Ofis Kira', amount: -3500, type: 'expense' },
    { id: 5, date: '01 Kas', description: 'Ali Ticaret - Ürün Satışı', amount: 5200, type: 'income' },
  ];

  return (
    <Layout activePage="home">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {/* Gelir */}
        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Bu Ay Gelir</p>
              <p className="text-3xl font-bold text-green-600">
                {stats.income.toLocaleString('tr-TR')}₺
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-2xl">💰</span>
            </div>
          </div>
        </div>

        {/* Gider */}
        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-red-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Bu Ay Gider</p>
              <p className="text-3xl font-bold text-red-600">
                {stats.expense.toLocaleString('tr-TR')}₺
              </p>
            </div>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <span className="text-2xl">💸</span>
            </div>
          </div>
        </div>

        {/* Net Kâr */}
        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Net Kâr</p>
              <p className="text-3xl font-bold text-blue-600">
                {stats.profit.toLocaleString('tr-TR')}₺
              </p>
              <p className="text-sm text-green-600 mt-1">↗ %15.3 geçen aya göre</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-2xl">📈</span>
            </div>
          </div>
        </div>
      </div>

      {/* Hızlı İşlemler */}
      <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Hızlı İşlemler</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <button className="flex flex-col items-center justify-center p-4 bg-green-50 hover:bg-green-100 rounded-lg transition">
            <span className="text-3xl mb-2">📄</span>
            <span className="text-sm font-medium text-green-700">Fatura Kes</span>
          </button>
          <button className="flex flex-col items-center justify-center p-4 bg-red-50 hover:bg-red-100 rounded-lg transition">
            <span className="text-3xl mb-2">💸</span>
            <span className="text-sm font-medium text-red-700">Gider Ekle</span>
          </button>
          <button className="flex flex-col items-center justify-center p-4 bg-blue-50 hover:bg-blue-100 rounded-lg transition">
            <span className="text-3xl mb-2">👤</span>
            <span className="text-sm font-medium text-blue-700">Müşteri Ekle</span>
          </button>
          <button className="flex flex-col items-center justify-center p-4 bg-purple-50 hover:bg-purple-100 rounded-lg transition">
            <span className="text-3xl mb-2">📦</span>
            <span className="text-sm font-medium text-purple-700">Stok Ekle</span>
          </button>
        </div>
      </div>

      {/* Son Hareketler */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Son Hareketler</h2>
          <button className="text-sm text-blue-600 hover:underline">Tümünü Gör</button>
        </div>
        <div className="space-y-3">
          {recentTransactions.map((transaction) => (
            <div
              key={transaction.id}
              className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition"
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    transaction.type === 'income' ? 'bg-green-100' : 'bg-red-100'
                  }`}
                >
                  <span className="text-lg">
                    {transaction.type === 'income' ? '↗' : '↘'}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">
                    {transaction.description}
                  </p>
                  <p className="text-xs text-gray-500">{transaction.date}</p>
                </div>
              </div>
              <p
                className={`text-lg font-semibold ${
                  transaction.type === 'income' ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {transaction.amount > 0 ? '+' : ''}
                {transaction.amount.toLocaleString('tr-TR')}₺
              </p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;